import React from 'react';
import { Link } from 'react-router-dom';
import Facebook from '../../assets/images/Facebook';
import Twitter from '../../assets/images/Twitter';
import Instagram from '../../assets/images/Instagram';
import LinkedIn from '../../assets/images/linkedIn';

export const socialLink = [
  {
    name: 'Facebook',
    icon: <Facebook />,
    url: 'https://www.facebook.com',
  },
  {
    name: 'Twitter',
    icon: <Twitter />,
    url: 'https://x.com',
  },
  {
    name: 'LinkedIn',
    icon: <LinkedIn />,
    url: 'https://www.linkedin.com',
  },
  {
    name: 'Instagram',
    icon: <Instagram />,
    url: 'https://www.instagram.com',
  },
];
const FollowUs = () => {
  return (
    <div>
      <ul className="d-flex social-icons">
        {socialLink.map((item, index) => {
          if (!item?.url) {
            return null;
          }
          return (
            <Link to={item?.url} target="_blank" rel="noopener noreferrer">
              <li className="rounded-circle" key={'key-' + index}>
                <i>{item?.icon}</i>
              </li>
            </Link>
          );
        })}
      </ul>
    </div>
  );
};

export default FollowUs;
